var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _g4, _path21, _path22, _path23, _g5, _path24, _path25, _path26, _path27, _path28, _g6, _path29, _path30, _path31, _g7, _path32, _path33, _path34, _path35, _path36, _g8, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6536 77.312C43.2811 77.312 49.4644 71.1287 49.4644 63.5012C49.4644 55.8737 43.2811 49.6904 35.6536 49.6904C28.0261 49.6904 21.8428 55.8737 21.8428 63.5012C21.8428 71.1287 28.0261 77.312 35.6536 77.312Z",
    fill: "#FABA2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3269 77.0103C42.9544 77.0103 49.1377 70.827 49.1377 63.1995C49.1377 55.572 42.9544 49.3887 35.3269 49.3887C27.6994 49.3887 21.5161 55.572 21.5161 63.1995C21.5161 70.827 27.6994 77.0103 35.3269 77.0103Z",
    fill: "#FEE480"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3271 74.8192C41.7444 74.8192 46.9467 69.617 46.9467 63.1996C46.9467 56.7823 41.7444 51.5801 35.3271 51.5801C28.9098 51.5801 23.7075 56.7823 23.7075 63.1996C23.7075 69.617 28.9098 74.8192 35.3271 74.8192Z",
    fill: "#FFCC34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5901 51.9282C39.3015 51.9282 42.6048 53.6669 44.7322 56.3764C42.6203 53.4715 39.1951 51.5801 35.3271 51.5801C28.91 51.5801 23.7075 56.7826 23.7075 63.1996C23.7075 65.9053 24.632 68.3963 26.185 70.371C24.7925 68.4544 23.9705 66.0968 23.9705 63.5478C23.9705 57.1307 29.173 51.9282 35.5901 51.9282Z",
    fill: "#FAAD05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.471 56.0264C45.8635 57.943 46.6855 60.3005 46.6855 62.8496C46.6855 69.2666 41.483 74.4691 35.0659 74.4691C31.3545 74.4691 28.0512 72.7305 25.9238 70.0209C28.0358 72.9258 31.4609 74.8173 35.3289 74.8173C41.746 74.8173 46.9485 69.6148 46.9485 63.1977C46.9485 60.492 46.024 58.001 44.471 56.0264Z",
    fill: "#FEEBA1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2807 52.9242C36.6674 52.9242 38.0134 53.1949 39.2802 53.7306C40.5044 54.249 41.603 54.9897 42.5468 55.9335C43.4906 56.8773 44.2313 57.9758 44.7496 59.2C45.2853 60.4668 45.5561 61.811 45.5561 63.1996C45.5561 64.5882 45.2853 65.9324 44.7496 67.1991C44.2313 68.4234 43.4906 69.5219 42.5468 70.4657C41.603 71.4095 40.5044 72.1502 39.2802 72.6685C38.0134 73.2043 36.6693 73.475 35.2807 73.475C33.892 73.475 32.5479 73.2043 31.2811 72.6685C30.0569 72.1502 28.9584 71.4095 28.0146 70.4657C27.0708 69.5219 26.33 68.4234 25.8117 67.1991C25.276 65.9324 25.0052 64.5882 25.0052 63.1996C25.0052 61.811 25.276 60.4668 25.8117 59.2C26.33 57.9758 27.0708 56.8773 28.0146 55.9335C28.9584 54.9897 30.0569 54.249 31.2811 53.7306C32.5479 53.1949 33.892 52.9242 35.2807 52.9242ZM35.2807 52.3652C29.2968 52.3652 24.4482 57.2157 24.4482 63.1977C24.4482 69.1796 29.2988 74.0301 35.2807 74.0301C41.2626 74.0301 46.1131 69.1796 46.1131 63.1977C46.1131 57.2157 41.2626 52.3652 35.2807 52.3652Z",
    fill: "#FFD95A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 49,
    width: 29,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2805 77.0103C42.908 77.0103 49.0913 70.827 49.0913 63.1995C49.0913 55.572 42.908 49.3887 35.2805 49.3887C27.653 49.3887 21.4697 55.572 21.4697 63.1995C21.4697 70.827 27.653 77.0103 35.2805 77.0103Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3103 46.0579L17.5518 69.8164L21.9813 74.2459L45.7398 50.4874L41.3103 46.0579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3059 51.0544L22.5474 74.813L23.6291 75.8947L47.3876 52.1362L46.3059 51.0544Z",
    fill: "white"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8722 56.4652C69.7389 56.4652 72.8734 53.3306 72.8734 49.464C72.8734 45.5974 69.7389 42.4629 65.8722 42.4629C62.0056 42.4629 58.8711 45.5974 58.8711 49.464C58.8711 53.3306 62.0056 56.4652 65.8722 56.4652Z",
    fill: "#FABA2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7062 56.3123C69.5728 56.3123 72.7073 53.1778 72.7073 49.3112C72.7073 45.4446 69.5728 42.3101 65.7062 42.3101C61.8396 42.3101 58.7051 45.4446 58.7051 49.3112C58.7051 53.1778 61.8396 56.3123 65.7062 56.3123Z",
    fill: "#FEE480"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9607 54.7533C70.9665 53.5083 72.3939 50.0622 71.1488 47.0564C69.9038 44.0505 66.4577 42.6231 63.4519 43.8682C60.446 45.1132 59.0186 48.5593 60.2637 51.5651C61.5087 54.571 64.9548 55.9984 67.9607 54.7533Z",
    fill: "#FFCC34"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8394 43.5964C67.7212 43.5964 69.3961 44.4783 70.4753 45.8515C69.4038 44.3777 67.6671 43.4204 65.7079 43.4204C62.4549 43.4204 59.8169 46.0584 59.8169 49.3114C59.8169 50.6826 60.2869 51.9456 61.0721 52.9474C60.3662 51.9765 59.9484 50.7813 59.9484 49.4874C59.9484 46.2344 62.5864 43.5964 65.8394 43.5964Z",
    fill: "#FAAD05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3421 45.6753C71.0481 46.6462 71.4658 47.8414 71.4658 49.1352C71.4658 52.3883 68.8278 55.0263 65.5748 55.0263C63.693 55.0263 62.0181 54.1443 60.939 52.7712C62.0104 54.2449 63.7472 55.2023 65.7063 55.2023C68.9593 55.2023 71.5973 52.5643 71.5973 49.3112C71.5973 47.94 71.1274 46.6771 70.3421 45.6753Z",
    fill: "#FEEBA1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.683 44.1031C66.387 44.1031 67.0678 44.2405 67.7099 44.5132C68.3307 44.7762 68.8877 45.1514 69.3654 45.6291C69.8431 46.1068 70.2202 46.6638 70.4813 47.2846C70.7521 47.9267 70.8913 48.6094 70.8913 49.3115C70.8913 50.0135 70.754 50.6962 70.4813 51.3383C70.2183 51.9591 69.8431 52.5161 69.3654 52.9938C68.8877 53.4715 68.3307 53.8487 67.7099 54.1097C67.0678 54.3805 66.3851 54.5198 65.683 54.5198C64.981 54.5198 64.2983 54.3824 63.6562 54.1097C63.0354 53.8467 62.4784 53.4715 62.0007 52.9938C61.523 52.5161 61.1458 51.9591 60.8847 51.3383C60.614 50.6962 60.4747 50.0135 60.4747 49.3115C60.4747 48.6094 60.612 47.9267 60.8847 47.2846C61.1478 46.6638 61.523 46.1068 62.0007 45.6291C62.4784 45.1514 63.0354 44.7743 63.6562 44.5132C64.2983 44.2424 64.981 44.1031 65.683 44.1031ZM65.683 43.8188C62.6505 43.8188 60.1904 46.277 60.1904 49.3115C60.1904 52.3459 62.6486 54.8041 65.683 54.8041C68.7175 54.8041 71.1756 52.3459 71.1756 49.3115C71.1756 46.277 68.7175 43.8188 65.683 43.8188Z",
    fill: "#FFD95A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 42,
    width: 15,
    height: 15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6828 56.3123C69.5494 56.3123 72.6839 53.1778 72.6839 49.3112C72.6839 45.4446 69.5494 42.3101 65.6828 42.3101C61.8162 42.3101 58.6816 45.4446 58.6816 49.3112C58.6816 53.1778 61.8162 56.3123 65.6828 56.3123Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7407 40.6211L56.6953 52.6665L58.9408 54.912L70.9863 42.8666L68.7407 40.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.273 43.1538L59.2275 55.1992L59.7759 55.7476L71.8214 43.7022L71.273 43.1538Z",
    fill: "white"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 65.2436L5.80419 60.7393L5.14662 61.7508C4.78883 62.3 6.04981 63.7525 7.96255 64.998C9.83081 66.2145 11.6314 66.7792 12.0453 66.2918C12.0549 66.2802 12.0646 66.2686 12.0723 66.257L12.7299 65.2455V65.2436Z",
    fill: "#F8AB05"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 65.2436L5.80419 60.7393L5.14662 61.7508C4.78883 62.3 6.04981 63.7525 7.96255 64.998C9.83081 66.2145 11.6314 66.7792 12.0453 66.2918C12.0549 66.2802 12.0646 66.2686 12.0723 66.257L12.7299 65.2455V65.2436Z",
    fill: "#FFC624"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 60,
    width: 8,
    height: 7
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 65.2436L5.80419 60.7393L5.14662 61.7508C4.78883 62.3 6.04981 63.7525 7.96255 64.998C9.83081 66.2145 11.6314 66.7792 12.0453 66.2918C12.0549 66.2802 12.0646 66.2686 12.0723 66.257L12.7299 65.2455V65.2436Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71434 62.9761L6.53125 61.5229L5.17987 63.5531L7.36296 65.0063L8.71434 62.9761Z",
    fill: "#FFE17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17624 60.5909L4.51123 63.1509L4.64904 63.2405L6.31405 60.6805L6.17624 60.5909Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60691 60.8712L4.94189 63.4312L5.0797 63.5208L6.74472 60.9608L6.60691 60.8712Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03562 61.1485L5.37061 63.7085L5.50841 63.7981L7.17343 61.2381L7.03562 61.1485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46628 61.4307L5.80127 63.9907L5.93907 64.0804L7.60409 61.5204L7.46628 61.4307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89499 61.71L6.22998 64.27L6.36778 64.3596L8.0328 61.7997L7.89499 61.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32566 61.9884L6.66064 64.5483L6.79845 64.638L8.46347 62.078L8.32566 61.9884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75339 62.2662L7.08838 64.8262L7.22619 64.9158L8.8912 62.3558L8.75339 62.2662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18601 62.5465L7.521 65.1064L7.6588 65.1961L9.32381 62.6361L9.18601 62.5465Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61472 62.8258L7.94971 65.3857L8.08751 65.4754L9.75252 62.9154L9.61472 62.8258Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0434 63.106L8.37842 65.666L8.51623 65.7556L10.1812 63.1957L10.0434 63.106Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4721 63.3853L8.80713 65.9453L8.94494 66.0349L10.61 63.475L10.4721 63.3853Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9013 63.6627L9.23633 66.2227L9.37414 66.3123L11.0392 63.7523L10.9013 63.6627Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3315 63.9449L9.6665 66.5049L9.80431 66.5945L11.4693 64.0345L11.3315 63.9449Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7607 64.2242L10.0957 66.7842L10.2335 66.8738L11.8985 64.3138L11.7607 64.2242Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1919 64.5011L10.5269 67.061L10.6647 67.1507L12.3297 64.5907L12.1919 64.5011Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6108 64.7804L10.9458 67.3403L11.0836 67.43L12.7486 64.87L12.6108 64.7804Z",
    fill: "#F9DC77"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7233 65.2545C13.0803 64.7056 11.8193 63.2523 9.90669 62.0083C7.99411 60.7644 6.15426 60.2009 5.79727 60.7498C5.44028 61.2987 6.70133 62.7521 8.61391 63.996C10.5265 65.2399 12.3663 65.8034 12.7233 65.2545Z",
    fill: "#FFCA34"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73998 62.2613C10.6412 62.8473 11.4226 63.4971 11.9351 64.0889C12.4457 64.6768 12.5134 65.0153 12.4669 65.0869C12.4205 65.1584 12.084 65.2319 11.3394 65.0056C10.589 64.7755 9.68003 64.3268 8.77877 63.7408C7.87752 63.1548 7.09619 62.5049 6.58367 61.9131C6.07309 61.3252 6.0054 60.9867 6.05182 60.9152C6.09823 60.8436 6.43475 60.7701 7.17935 60.9964C7.92974 61.2266 8.83873 61.6753 9.73998 62.2613ZM9.90631 62.006C7.99357 60.7624 6.15432 60.1996 5.79653 60.7469C5.43873 61.2962 6.69971 62.7486 8.61245 63.9941C10.5252 65.2377 12.3644 65.8005 12.7222 65.2532C13.08 64.7039 11.8191 63.2515 9.90631 62.006Z",
    fill: "#FCE280"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.372 64.8919C12.3256 64.9635 11.9891 65.037 11.2445 64.8107C10.4941 64.5805 9.58508 64.1319 8.68383 63.5459C7.78257 62.9598 7.00123 62.31 6.48872 61.7182C6.29918 61.5016 6.17154 61.3179 6.08838 61.1689C6.15607 61.3391 6.30305 61.5867 6.58542 61.9116C7.09986 62.5034 7.87927 63.1532 8.78053 63.7393C9.68178 64.3253 10.5927 64.7759 11.3412 65.0041C12.0858 65.2323 12.4223 65.1569 12.4687 65.0853C12.4977 65.0408 12.4822 64.89 12.3372 64.6366C12.3913 64.7739 12.3933 64.859 12.372 64.89V64.8919Z",
    fill: "#FCE99F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14055 61.0972C6.18697 61.0257 6.52348 60.9522 7.26808 61.1785C8.01848 61.4086 8.92747 61.8573 9.82872 62.4433C10.73 63.0293 11.5113 63.6792 12.0238 64.271C12.2134 64.4876 12.341 64.6713 12.4242 64.8202C12.3565 64.65 12.2095 64.4025 11.9271 64.0776C11.4127 63.4858 10.6333 62.8359 9.73202 62.2499C8.83077 61.6639 7.91984 61.2133 7.17138 60.9851C6.42678 60.7569 6.09027 60.8323 6.04385 60.9038C6.01484 60.9483 6.03031 61.0992 6.17536 61.3525C6.12121 61.2152 6.11928 61.1301 6.14055 61.0992V61.0972Z",
    fill: "#F8AB05"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 60,
    width: 8,
    height: 6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7165 65.2565C13.0735 64.7076 11.8124 63.2542 9.89985 62.0103C7.98728 60.7663 6.14743 60.2029 5.79044 60.7518C5.43344 61.3006 6.69449 62.754 8.60707 63.998C10.5196 65.2419 12.3595 65.8054 12.7165 65.2565Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M9.7107 57.4479L4.83643 65.2393L6.28912 66.1481L11.1634 58.3567L9.7107 57.4479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M11.3479 58.4713L6.47363 66.2627L6.82779 66.4843L11.7021 58.6929L11.3479 58.4713Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.599 2.53711L57.7017 11.186L58.9665 13.8008C59.6511 15.2185 64.2135 14.4332 69.1568 12.0447C73.9861 9.71037 77.3919 6.71072 76.9045 5.25053C76.8929 5.21572 76.8794 5.18284 76.8639 5.1519L75.599 2.53711Z",
    fill: "#F8AB05"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.599 2.53711L57.7017 11.186L58.9665 13.8008C59.6511 15.2185 64.2135 14.4332 69.1568 12.0447C73.9861 9.71037 77.3919 6.71072 76.9045 5.25053C76.8929 5.21572 76.8794 5.18284 76.8639 5.1519L75.599 2.53711Z",
    fill: "#FFC624"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 2,
    width: 20,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.599 2.53711L57.7017 11.186L58.9665 13.8008C59.6511 15.2185 64.2135 14.4332 69.1568 12.0447C73.9861 9.71037 77.3919 6.71072 76.9045 5.25053C76.8929 5.21572 76.8794 5.18284 76.8639 5.1519L75.599 2.53711Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9349 7.95304L60.2261 10.6382L62.7227 15.9462L68.4315 13.2611L65.9349 7.95304Z",
    fill: "#FFE17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2134 10.065L57.8599 10.2358L61.0565 16.8513L61.41 16.6805L58.2134 10.065Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3262 9.53085L58.9727 9.70166L62.1693 16.3172L62.5228 16.1463L59.3262 9.53085Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.435 8.99472L60.0815 9.16553L63.2782 15.781L63.6317 15.6102L60.435 8.99472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5449 8.45517L61.1914 8.62598L64.388 15.2415L64.7415 15.0707L61.5449 8.45517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6553 7.91903L62.3018 8.08984L65.4984 14.7053L65.8519 14.5345L62.6553 7.91903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7656 7.38338L63.4121 7.5542L66.6087 14.1697L66.9622 13.9989L63.7656 7.38338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.876 6.8453L64.5225 7.01611L67.7191 13.6316L68.0726 13.4608L64.876 6.8453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9829 6.31015L65.6294 6.48096L68.826 13.0965L69.1795 12.9256L65.9829 6.31015Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0932 5.7745L66.7397 5.94531L69.9364 12.5608L70.2899 12.39L67.0932 5.7745Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2036 5.23837L67.8501 5.40918L71.0467 12.0247L71.4002 11.8539L68.2036 5.23837Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3144 4.70223L68.9609 4.87305L72.1576 11.4885L72.5111 11.3177L69.3144 4.70223Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4243 4.16463L70.0708 4.33545L73.2674 10.9509L73.6209 10.7801L70.4243 4.16463Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5351 3.63094L71.1816 3.80176L74.3783 10.4173L74.7318 10.2464L71.5351 3.63094Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.646 3.09286L72.2925 3.26367L75.4891 9.87917L75.8426 9.70836L72.646 3.09286Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7539 2.55526L73.4004 2.72607L76.597 9.34157L76.9505 9.17076L73.7539 2.55526Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8467 2.04012L74.4932 2.21094L77.6898 8.82643L78.0433 8.65562L74.8467 2.04012Z",
    fill: "#F9DC77"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9073 9.46134C72.8496 7.07317 76.3005 3.98721 75.6151 2.56865C74.9296 1.15009 70.3674 1.93611 65.425 4.32428C60.4827 6.71244 57.0317 9.79841 57.7172 11.217C58.4027 12.6355 62.9649 11.8495 67.9073 9.46134Z",
    fill: "#FFCA34"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7397 4.97573C68.0702 3.85013 70.3775 3.05332 72.2361 2.73227C74.0811 2.41509 74.8625 2.69359 74.9514 2.87925C75.0404 3.06492 74.7735 3.85013 73.3791 5.09757C71.973 6.35468 69.9152 7.66788 67.5847 8.79348C65.2543 9.91907 62.947 10.7159 61.0884 11.0369C59.2433 11.3541 58.462 11.0756 58.373 10.8899C58.2841 10.7043 58.551 9.91907 59.9454 8.67163C61.3514 7.41452 63.4092 6.10133 65.7397 4.97573ZM65.4206 4.31623C60.4792 6.70474 57.0289 9.79143 57.7135 11.2091C58.3982 12.6267 62.9605 11.8415 67.9039 9.45298C72.8453 7.06447 76.2956 3.97778 75.6109 2.56014C74.9263 1.14251 70.3639 1.92772 65.4206 4.31623Z",
    fill: "#FCE280"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4329 2.83306C74.5218 3.01873 74.2549 3.80394 72.8605 5.05138C71.4545 6.30849 69.3967 7.62168 67.0662 8.74728C64.7357 9.87288 62.4284 10.6697 60.5698 10.9907C59.8871 11.1087 59.3495 11.1435 58.9395 11.1339C59.3727 11.2073 60.067 11.2132 61.0882 11.0372C62.9467 10.7161 65.254 9.91929 67.5845 8.7937C69.915 7.6681 71.9728 6.3549 73.3788 5.09779C74.7732 3.85035 75.0401 3.06514 74.9512 2.87948C74.8951 2.76344 74.5644 2.60871 73.8662 2.59131C74.2143 2.64933 74.3922 2.75183 74.4329 2.83306Z",
    fill: "#FCE99F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8638 10.9347C58.7748 10.749 59.0417 9.96377 60.4362 8.71633C61.8422 7.45922 63.9 6.14603 66.2305 5.02043C68.561 3.89483 70.8682 3.09802 72.7268 2.77697C73.4095 2.659 73.9472 2.62418 74.3572 2.63385C73.924 2.56036 73.2297 2.55456 72.2085 2.73055C70.3499 3.0516 68.0426 3.84842 65.7122 4.97401C63.3817 6.09961 61.3239 7.41281 59.9178 8.66992C58.5234 9.91736 58.2565 10.7026 58.3455 10.8882C58.4016 11.0043 58.7323 11.159 59.4305 11.1764C59.0824 11.1184 58.9044 11.0159 58.8638 10.9347Z",
    fill: "#F8AB05"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 1,
    width: 19,
    height: 11
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8999 9.47941C72.8423 7.09124 76.2932 4.00527 75.6078 2.58671C74.9223 1.16815 70.3601 1.95418 65.4177 4.34234C60.4753 6.73051 57.0244 9.81647 57.7099 11.235C58.3953 12.6536 62.9576 11.8676 67.8999 9.47941Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M55.7997 -0.952289L65.7676 18.7808L69.4463 16.9225L59.4784 -2.81053L55.7997 -0.952289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M59.9511 -3.04897L69.9189 16.6841L70.8166 16.2306L60.8487 -3.50241L59.9511 -3.04897Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4554 47.188L28.8132 48.7952C29.1285 50.2147 30.2367 51.321 31.6543 51.6362L33.2615 51.994L31.6543 52.3518C30.2347 52.6671 29.1285 53.7752 28.8132 55.1929L28.4554 56.8L28.0977 55.1929C27.7824 53.7733 26.6742 52.6671 25.2566 52.3518L23.6494 51.994L25.2566 51.6362C26.6761 51.321 27.7824 50.2128 28.0977 48.7952L28.4554 47.188Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.90341 38.2046C1.89749 41.5543 7.43652 42.8655 13.2734 41.1346C19.1102 39.4037 23.0363 35.2823 22.0422 31.9306L21.3576 28.813L0.220703 35.0869L0.905346 38.2046H0.90341Z",
    fill: "#FFC624"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 23,
    height: 14
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.92636 38.1616C1.92044 41.5113 7.45946 42.8226 13.2963 41.0916C19.1332 39.3588 23.0592 35.2393 22.0652 31.8877L21.3805 28.77L0.243652 35.044L0.92829 38.1616H0.92636Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8175 42.0271L21.5059 39.9644L19.5879 33.7454L12.8996 35.8081L14.8175 42.0271Z",
    fill: "#FFE17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5821 29.1681L20.1631 29.2925L23.7013 41.2142L24.1203 41.0899L20.5821 29.1681Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2711 29.5578L18.8521 29.6821L22.3902 41.6039L22.8093 41.4795L19.2711 29.5578Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.963 29.9474L17.5439 30.0718L21.0821 41.9935L21.5011 41.8692L17.963 29.9474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6519 30.3351L16.2329 30.4595L19.7711 42.3812L20.1901 42.2569L16.6519 30.3351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3394 30.7252L14.9204 30.8496L18.4586 42.7714L18.8776 42.647L15.3394 30.7252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0284 31.1149L13.6094 31.2393L17.1476 43.161L17.5666 43.0367L14.0284 31.1149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7174 31.5031L12.2983 31.6274L15.8365 43.5492L16.2555 43.4248L12.7174 31.5031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4068 31.8908L10.9878 32.0151L14.526 43.9369L14.945 43.8125L11.4068 31.8908Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0963 32.2819L9.67725 32.4062L13.2154 44.328L13.6344 44.2037L10.0963 32.2819Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78524 32.6701L8.36621 32.7944L11.9044 44.7162L12.3234 44.5918L8.78524 32.6701Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47469 33.0578L7.05566 33.1821L10.5938 45.1039L11.0129 44.9795L7.47469 33.0578Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1617 33.4479L5.74268 33.5723L9.28085 45.494L9.69988 45.3697L6.1617 33.4479Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85067 33.8356L4.43164 33.96L7.96982 45.8817L8.38884 45.7574L4.85067 33.8356Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54256 34.2272L3.12354 34.3516L6.66171 46.2733L7.08074 46.149L3.54256 34.2272Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23152 34.6149L1.8125 34.7393L5.35068 46.661L5.7697 46.5367L2.23152 34.6149Z",
    fill: "#F9DC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.950269 35.0187L0.53125 35.1431L4.06943 47.0648L4.48845 46.9405L0.950269 35.0187Z",
    fill: "#F9DC77"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98766 25.8827C3.1508 27.6156 -0.77525 31.735 0.218834 35.0867C1.21292 38.4364 6.75194 39.7477 12.5888 38.0167C18.4257 36.2838 22.3517 32.1644 21.3576 28.8127C20.3635 25.463 14.8245 24.1518 8.98766 25.8827Z",
    fill: "#FFCA34"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6848 27.1225C19.5996 27.6389 20.1817 28.3022 20.4157 29.0913C20.5975 29.7044 20.5608 30.3755 20.3036 31.0853C20.0328 31.8376 19.5338 32.5957 18.824 33.3423C18.0833 34.1197 17.155 34.8353 16.0681 35.4678C14.927 36.1311 13.6622 36.6726 12.3103 37.073C10.4904 37.6126 8.63179 37.8582 6.93372 37.7828C5.33235 37.7112 3.93599 37.3631 2.89356 36.7732C1.97877 36.2568 1.39663 35.5935 1.16262 34.8044C0.98082 34.1913 1.01756 33.5202 1.27479 32.8104C1.54555 32.0581 2.04452 31.2999 2.75431 30.5534C3.49504 29.7759 4.42336 29.0604 5.51028 28.4279C6.65135 27.7646 7.9162 27.223 9.26807 26.8227C11.088 26.2831 12.9466 26.0375 14.6446 26.1129C16.246 26.1845 17.6424 26.5326 18.6848 27.1225ZM19.1664 26.2676C16.8107 24.9351 12.9678 24.7011 8.98571 25.8828C3.14885 27.6156 -0.777203 31.7351 0.216881 35.0868C0.532125 36.1524 1.30767 37.0111 2.40619 37.6319C4.76182 38.9645 8.60471 39.1985 12.5868 38.0168C18.4237 36.2839 22.3498 32.1645 21.3557 28.8128C21.0404 27.7472 20.2649 26.8885 19.1664 26.2676Z",
    fill: "#FCE280"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53531 31.1062C3.27604 30.3287 4.20437 29.6131 5.29128 28.9807C6.43235 28.3174 7.6972 27.7758 9.04908 27.3755C10.869 26.8359 12.7276 26.5903 14.4256 26.6657C16.027 26.7373 17.4234 27.0854 18.4658 27.6753C19.3806 28.1916 19.9627 28.855 20.1967 29.6441C20.3186 30.0522 20.3418 30.4854 20.2683 30.9399C20.4907 30.2707 20.5159 29.6364 20.3437 29.0542C20.1097 28.2651 19.5276 27.6018 18.6128 27.0854C17.5704 26.4955 16.174 26.1474 14.5726 26.0758C12.8746 26.0004 11.016 26.246 9.19606 26.7856C7.84418 27.186 6.57934 27.7275 5.43827 28.3909C4.35135 29.0233 3.42303 29.7389 2.6823 30.5163C1.97251 31.2629 1.47354 32.021 1.20278 32.7733C1.11768 33.0112 1.05579 33.2433 1.01904 33.4734C1.03065 33.4367 1.04225 33.4019 1.05579 33.3651C1.32655 32.6128 1.82553 31.8547 2.53531 31.1081V31.1062Z",
    fill: "#F8AB05"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0866 31.6362C20.1717 31.3983 20.2336 31.1662 20.2703 30.936C20.2587 30.9728 20.2471 31.0076 20.2336 31.0443C19.9628 31.7967 19.4639 32.5548 18.7541 33.3013C18.0133 34.0788 17.085 34.7944 15.9981 35.4268C14.857 36.0902 13.5922 36.6317 12.2403 37.0321C10.4204 37.5716 8.5618 37.8173 6.86374 37.7418C5.26237 37.6703 3.86602 37.3222 2.82358 36.7323C1.90879 36.2159 1.32665 35.5525 1.09264 34.7635C0.970793 34.3554 0.947586 33.9222 1.02108 33.4677C0.798666 34.1368 0.773521 34.7712 0.945649 35.3533C1.17966 36.1424 1.76181 36.8058 2.6766 37.3222C3.71903 37.912 5.11539 38.2602 6.71676 38.3317C8.41482 38.4071 10.2734 38.1615 12.0933 37.6219C13.4452 37.2216 14.71 36.6801 15.8511 36.0167C16.938 35.3843 17.8664 34.6687 18.6071 33.8912C19.3169 33.1447 19.8158 32.3865 20.0866 31.6342V31.6362Z",
    fill: "#FCE99F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_188_3960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 25,
    width: 22,
    height: 14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97204 25.7938C3.13518 27.5267 -0.790875 31.6462 0.203209 34.9978C1.19729 38.3475 6.73632 39.6588 12.5732 37.9278C18.41 36.195 22.3361 32.0755 21.342 28.7239C20.3479 25.3742 14.8089 24.0629 8.97204 25.7938Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_188_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M10.5427 20.9929L17.1045 44.6221L21.5098 43.3987L14.948 19.7696L10.5427 20.9929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M8.90156 21.4505L15.4634 45.0796L16.5386 44.781L9.97679 21.1519L8.90156 21.4505Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6055 44.463C35.4411 44.463 35.3096 44.3295 35.3096 44.167V20.8467C35.3096 20.6823 35.443 20.5508 35.6055 20.5508C35.7679 20.5508 35.9014 20.6842 35.9014 20.8467V44.167C35.9014 44.3314 35.7679 44.463 35.6055 44.463Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M38.94 44.4629C38.7756 44.4629 38.644 44.3294 38.644 44.167V34.6284C38.644 34.464 38.7775 34.3325 38.94 34.3325C39.1024 34.3325 39.2359 34.466 39.2359 34.6284V44.167C39.2359 44.3314 39.1024 44.4629 38.94 44.4629Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3662 44.4625C32.2018 44.4625 32.0703 44.3291 32.0703 44.1666V28.7603C32.0703 28.5959 32.2038 28.4644 32.3662 28.4644C32.5287 28.4644 32.6621 28.5978 32.6621 28.7603V44.1666C32.6621 44.331 32.5287 44.4625 32.3662 44.4625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/noFound.742d4b4e176334f8b0d35e0d443e520d.svg";
export { ForwardRef as ReactComponent };